import React, { useState } from 'react';
import { Controller, useForm} from 'react-hook-form';
import { useGlobal, getGlobal } from 'reactn';
import { notification, DatePicker as AntDatePicker} from 'antd';
import api from '../../../api/';
import Button from '../../common/button/Button';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'; 
import './react-tabs.scss'
import './Tabs.scss';

const MovingForms = ({ closeHandler, requestSubmitted }) => {
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];
  const [loading, setLoading] = useState(false);
  // fututure development needed to validate and display errors 
  const [errorMessage, setErrorMessage] = useState(null);
 
  
 // hook up form and input fields with useForm
 // create distinct 'buy' and 'sell' forms to integrate with react-hook-form features

 const buyForm = useForm({mode: "onChange"});
 const sellForm = useForm({mode: "onChange"});

  const {
    SA_STRNUM,
    SA_STRNAME,
    SA_CITY,
    SA_ZIP_CODE,
  } = selectedServiceAccount.data;


  const submitHandler = (type_of_move) => async ({
    names_on_house,
    mailing_address,
    new_mailing_address,
    attorney_question,
    contact_phone,
    names_of_new_owners,
    address_being_sold,
    address_being_bought,
    closingDate,
    moveoutDate,
    moveinDate,
    
  }) => {
    setLoading(true);
    const { user } = getGlobal();
    const { first_name, last_name, email } = user;
    const movingInfo = {
      accountNumber: selectedServiceAccount.data.ACCOUNT,
      customerCode: selectedServiceAccount.data.CUST_CODE,
      type_of_move,
      closingDate,
      moveoutDate,
      moveinDate,
      names_on_house,
      mailing_address,
      new_mailing_address,
      attorney_question,
      contact_phone,
      names_of_new_owners,
      [type_of_move === 'Sell' ? 'address_being_sold' : null]:
        address_being_sold === undefined || address_being_sold === ''
          ? `${SA_CITY}, ${SA_STRNUM}, ${SA_STRNAME}, ${SA_ZIP_CODE}`
          : address_being_sold,
      address_being_bought,
      first_name,
      last_name,
      email,
    };

    try {
      await api.submitMovingRequest(movingInfo);
      closeHandler();
      requestSubmitted(true);
      notification.success({
        message: `Your moving request has been successfully submitted`,
      });
    } catch (err) {
      const errorMessage =
        err.response?.data.error ||
        'There was a problem submitting the request. Please contact support if the issue persists.';
      setErrorMessage(errorMessage);
    }
    setLoading(false);
  };


const renderSell = (control, register) => {
  return(
      <>
          <label htmlFor="address-being-sold-input"> Address of Property Being Sold </label>
          <input type="text" id="address-being-sold-input" className="p-4 my-2 h-auto text-lg border rounded-none"
            placeholder="Address"
            defaultValue={`${SA_STRNUM}, ${SA_STRNAME}, ${SA_CITY}, ${SA_ZIP_CODE}`}
            {...register("address_being_sold" )
            }
           />  

          <label htmlFor="contact_phone">Contact Phone Number </label> 
          <input type="text" id="contact_phone"  className="p-4 my-2 h-auto text-lg border rounded-none"
            placeholder="Enter contact phone number"          
            {...register("contact_phone" 
            )}
          />

          <div>
          <label label="Closing Date" htmlFor="closing_date"> Closing Date</label>
          <Controller
            name="closingDate"
            dateName="closing_date"             
            placeholder="Closing Date"
            input type="date"
            control={control}                               
            render={({ field }) => (<AntDatePicker
              label="date dialog"
              id="closing_date"
              format="MM/DD/YYYY"
              placeholder="Select Closing Date"
              selected={field.value}
              onChange={(date) => field.onChange(date)}
              className="mb-4 p-4 my-2 text-lg border rounded-none w-full"
              {...field}
               />           
            )}           
          />
          </div>

          <div>
          <label label="Move-out Date" htmlFor="move_out_date"> Move-out Date</label>
          <Controller
            name="moveoutDate"
            dateName="move_out_date"
            placeholder="Move-out Date"
            input type="date"
            control={control}            
            render={({field  }) => (<AntDatePicker
              label="date dialog"
              id="move_out_date"
              format="MM/DD/YYYY"
              placeholder="Select Move-out Date"
              selected={field.value}
              onChange={(date) => field.onChange(date)}
              className="mb-4 p-4 my-2 text-lg border rounded-none w-full"
              {...field}      
                />
            )}
          />
          </div>   
 
          <label htmlFor="names-of-new-owners"> New Owner(s) Name as it appears on deed of the Property</label> 
          <input type="text" id="names-of-new-owners" className="p-4 my-2 h-auto text-lg border rounded-none" placeholder="Enter new owner(s) names here"
          {...register("names_of_new_owners")}
          />  

          <label htmlFor="new-mailing-address-input"> Mailing Address to send final bill</label> 
          <input type="text" id="new-mailing-address-input" className="p-4 my-2 h-auto text-lg border rounded-none"  placeholder="Enter mailing address here"
          {...register("new_mailing_address")}
          />  

          <label htmlFor="attorney-question-input"> Name of Attorney representing you at closing</label> 
          <input type="text" id="attorney-question-input" className="p-4 my-2 h-auto text-lg border rounded-none"  placeholder="Enter name of attorney here"
          {...register("attorney_question")}
          />  
    </>
  );
};

  const renderBuy = (control, register) => {
    return(
      <>      
              <label htmlFor="new-property-address-input">   Address of New Property </label>        
              <input type="text" id="new-property-address-input" className="p-4 my-2 h-auto text-lg border rounded-none"  
                name="address_being_bought" 
                placeholder="Enter new property address"
                control={control}
                {...register("address_being_bought")}
              />          
               
              <label htmlFor="contact-phone-input"> Contact Phone Number</label> 
              <input type="text" id="contact-phone-input" className="p-4 my-2 h-auto text-lg border rounded-none"  placeholder="Enter contact phone number"
              {...register("contact_phone")}
              />  
           
           <div>
          <label label="Closing Date" htmlFor="closing_date"> Closing Date</label>
          <Controller
            name="closingDate"
            dateName="closing_date"          
            placeholder="Closing Date"
            input type="date"
            control={control}
            render={({field  }) => (<AntDatePicker
              label="date dialog"
              id="closing_date"
              format="MM/DD/YYYY"
              placeholder="Select Closing Date"
              selected={field.value}
              onChange={(date) => field.onChange(date)}
              className="mb-4 p-4 my-2 text-lg border rounded-none w-full"
              {...field}
               />
          )}
          />
          </div>

        <div>
          <label label="Move-in Date" htmlFor="move_in_date">  Move-in Date </label>
          <Controller
            name="moveinDate"
            dateName="move_in_date"
            input type="date"
            control={control}
            placeholder="Move-in Date"
            render={({field  }) => (<AntDatePicker
              label="date dialog"
              id="move_in_date"
              format="MM/DD/YYYY"
              placeholder="Select Move-in Date"
              onChange={(date) => field.onChange(date)}
              className="mb-4 p-4 my-2 text-lg border rounded-none w-full"
              {...field}
               />
          )}
          />

        </div>   
          <label htmlFor="names-on-house"> Name(s) that will appear on the deed of the house</label> 
          <input type="text" id="names-on-house" className="p-4 my-2 h-auto text-lg border rounded-none" placeholder="Enter name(s)"
            {...register("names_on_house"
            )} 
          />  

          <label htmlFor="mailing-address-input"> Mailing Address (if different than service address)</label> 
          <input type="text" id="mailing-address-input" className="p-4 my-2 h-auto text-lg border rounded-none" placeholder="Enter mailing address"
            {...register("mailing_address")}
          />      
        
          <label htmlFor="attorney-question-input"> Name of attorney handling the closing for you</label> 
          <input type="text" id="attorney-question-input" className="p-4 my-2 h-auto text-lg border rounded-none" placeholder="Enter name of attorney"
            {...register("attorney_question")}
          /> 
    </>
    );
  };

   
  return (
    
    <Tabs  className='RRT__container'  >
        <TabList className='flex flex-col lg:flex-row RRT__tabs ' >
          <Tab className='p-8 flex-grow justify-center items-center text-center text-2xl cursor-pointer bg-blue-dark text-white flex flex-column opacity-75'>
            Buying A Property?
          </Tab>
          <Tab className='p-8 flex-grow justify-center items-center text-center text-2xl cursor-pointer bg-blue-dark text-white flex flex-column opacity-75'>
            Selling A Property?
          </Tab>
        </TabList>
        
          <TabPanel>
                  
             <form className='p-8 flex flex-col' 
              onSubmit={ buyForm.handleSubmit(submitHandler('Buy'))}
             > 
              {renderBuy(buyForm.control, buyForm.register)}
            <div className="mx-auto w-full flex justify-between"> 
           
            <Button
              loading={loading}
              className="mr-5 w-1/2 text-center"
              htmlType="submit"
              onClick={() => submitHandler('Buy')}  
            >
              Submit
            </Button>
            <Button
              disabled={loading}
              className="w-1/2 text-center"
              secondary
              htmlType="button"
              onClick={() => closeHandler()}
            >
              Cancel
            </Button>         
            </div>            
            </form >          
          </TabPanel>
  
          <TabPanel>
            
            <form  className='p-8 flex flex-col' 
              onSubmit={ sellForm.handleSubmit(submitHandler('Sell'))}
            >
              {renderSell(sellForm.control, sellForm.register)}
              <div className="mx-auto w-full flex justify-between"> 
           
           <Button
             loading={loading}
             className="mr-5 w-1/2 text-center"
             htmlType="submit"
             onClick={() => submitHandler('Sell')}
           >
             Submit
           </Button>
           <Button
             disabled={loading}
             className="w-1/2 text-center"
             secondary
             htmlType="button"
             onClick={() => closeHandler()}
           >
             Cancel
           </Button>         
           </div>        
          </form>          
        </TabPanel>
    </Tabs>
  ); 
};

export default MovingForms;
